export const historyRoutes = {
  availableDataFeed: '/subscriberportal/availabledatafeed',
  dataFeedPolicy: '/subscriberportal/datafeedpolicy',
  subscribedDataFeed: '/subscriberportal/subscriberdatafeed',
  clearAllLanesText: 'subscriberdatafeed',
  selectedCloseAllText: 'Selected close all',
  selectedBlockAllText: 'Selected block all',
};
